import { Order } from "@/entities/order/order";
import { ICalculatePriceRepository } from "@/repositories";
import { ICalculatePriceService } from "./calculatePrice.types";

export class CalculatePriceService implements ICalculatePriceService {
    constructor(private repository: ICalculatePriceRepository) {}

    async getCost(input: Order, apikey: string): Promise<Order> {
        return this.repository.getCost(input, apikey);
    }

    async suggestCoupon(input: Order, apikey: string): Promise<any>  {
        return this.repository.suggestCoupon(input, apikey);
    }

    async getResolveCoupon(input: Order, apikey: string): Promise<Order>{
        console.log("getResolveCoupon", input);
        return this.repository.getResolveCoupon(input, apikey);
    }

    // async createSale(userData: ISaleData): Promise<ISale> {
    //     return (await this.repository.create(userData));
    // }

    // async syncSale(userData: ISaleData): Promise<ISale> {
    //     const user = await this.getSaleById(userData.id as string);
    //     if(user){
    //         return user;
    //     }
    //     return await this.createSale(userData);
    // }
}
